import { KestrelVersion } from "type/kestrel-version";
import { PlatformChoice } from "type/platform-choice";

/**
 * Who sees what on the IDX page's Version and IDX Pages sections (MAX-4577). Kept apart from the
 * page so the conditions can be tested on their own.
 */

/**
 * Sites with the Wix app always run v10, so there is no version to choose. Only the installed app
 * decides it: a site stored as Wix without the app keeps the choice, as on the old page.
 */
export function showVersionChoice(listingDetail: boolean, wixAppInstalled: boolean): boolean {
	return listingDetail && !wixAppInstalled;
}

/**
 * Whether picking `next` asks "Switch versions?" first. It follows the direction of the switch, not
 * page state, which can't say whether a site is live: leaving v10 breaks the site's v10 embed codes
 * (IDX pages, widgets, the head script), and moving up never does. WordPress re-renders its own
 * pages, so it is never asked.
 */
export function versionSwitchGuarded(platform: PlatformChoice, saved: KestrelVersion, next: KestrelVersion): boolean {
	return !platform.wordpress && saved.all && !next.all;
}

/** A non-WordPress site moving up to v10, which needs setting up once saved: the Version section says so. */
export function upgradeNeedsSetup(platform: PlatformChoice, saved: KestrelVersion, next: KestrelVersion): boolean {
	return !platform.wordpress && !saved.all && next.all;
}

/** Every non-WordPress site needs the head script, unless the Wix app is installed. */
export function showHeadScript(platform: PlatformChoice, wixAppInstalled: boolean): boolean {
	return !platform.wordpress && !wixAppInstalled;
}
